// Sport route for /bet/sport/:sportId
// Provides sportId param to parent layout via useMatches — no visible UI here
export default function BetSport() {
  return null;
}
